
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function CaseStudyPreviewSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#1B365D] mb-6">Real Results, Real Impact</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              See how we've helped service companies transform their revenue operations and achieve predictable growth
            </p>
          </div>

          {/* Featured Case Study */}
          <div className="bg-gradient-to-r from-[#1B365D] to-[#2BB6A3] rounded-2xl p-8 md:p-12 text-white">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-bold mb-6">TechConsult Pro</h3>
                <p className="text-xl mb-8 opacity-90">
                  Sacramento-based IT consulting firm struggling with inconsistent lead generation and founder dependency
                </p>
                
                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="text-center">
                    <div className="text-4xl font-bold text-[#2BB6A3] mb-2">$180K</div>
                    <div className="text-sm opacity-80">Monthly Revenue Before</div>
                  </div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-white mb-2">$720K</div>
                    <div className="text-sm opacity-80">Monthly Revenue After</div>
                  </div>
                </div>

                <div className="bg-white/10 rounded-lg p-6 mb-8">
                  <h4 className="font-bold mb-4">Key Improvements:</h4>
                  <ul className="space-y-2">
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#2BB6A3] mr-3"></i>
                      Automated lead qualification system
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#2BB6A3] mr-3"></i>
                      AI-powered outbound sequences
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#2BB6A3] mr-3"></i>
                      Predictable sales pipeline
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#2BB6A3] mr-3"></i>
                      Reduced founder dependency by 80%
                    </li>
                  </ul>
                </div>

                <Link to="/case-studies">
                  <Button 
                    variant="secondary" 
                    className="border-2 border-white text-white hover:bg-white hover:text-[#1B365D] whitespace-nowrap"
                  >
                    View Full Case Study
                  </Button>
                </Link>
              </div>

              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/f3375ab72d7f65b358dc6cf884e758f7/bf982d6551cae17c0870abffd24ce017.jpeg"
                  alt="TechConsult Pro success story - revenue growth visualization"
                  className="rounded-lg shadow-2xl object-cover object-top w-full h-80"
                />
                <div className="absolute -bottom-6 -right-6 bg-[#2BB6A3] rounded-lg p-4 shadow-lg">
                  <div className="text-center">
                    <div className="text-2xl font-bold">400%</div>
                    <div className="text-sm">Growth in 12 Months</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
